// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container-form-label-point {
  width: 100%;
  height: 100%;
  padding: 10px;
  background-color: var(--background-color-4);
}

.container-footer-lable-point{
    width: 100%;
    padding: 5px 5px 0 5px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
}
.input-form-label{
  margin: 2px 0 5px 0;
}`, "",{"version":3,"sources":["webpack://./src/styles/Dialog/formLabelPoint.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,2CAA2C;AAC7C;;AAEA;IACI,WAAW;IACX,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,yBAAyB;AAC7B;AACA;EACE,mBAAmB;AACrB","sourcesContent":[".container-form-label-point {\r\n  width: 100%;\r\n  height: 100%;\r\n  padding: 10px;\r\n  background-color: var(--background-color-4);\r\n}\r\n\r\n.container-footer-lable-point{\r\n    width: 100%;\r\n    padding: 5px 5px 0 5px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: flex-end;\r\n}\r\n.input-form-label{\r\n  margin: 2px 0 5px 0;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
